import React, { useState } from 'react'
import { Redirect, Route, Switch, useParams, withRouter } from "react-router-dom";

import usePageLogin from "tools/utils/hooks/usePageLogin";

import globalStoreContext from '../globalStore'
import routers from './Router'
import { reportPoint } from "wmda_bx_report";
import useVisitReport from "tools/utils/hooks/useVisitReport";





// 如果后期需要添加一下公用的方法，
const CommonPage = props => {
    //增加页面浏览埋点
    reportPoint(Object.assign({}, props.point, useParams()));

    // 判断页面是否需要进行登录
    usePageLogin();

    // 页面访问上报
    useVisitReport();

    const C = props.component;

    return <C {...props}/>;
}

const MainRouter = withRouter(() =>  {
    return (
        <Switch>
            {
                routers.map((item, index) => {
                    return (
                        <Route key={index} path={item.path} render={props => (
                            <CommonPage point={item.point} component={item.component} {...props}/>
                        )}/>
                    )
                })
            }

            <Redirect to='/home'/>
        </Switch>
    )
})

export default () => {
    const [global, setGlobal] = useState({});

    return (
        <globalStoreContext.Provider value={{global, setGlobal}}>
            <MainRouter />
        </globalStoreContext.Provider>
    )
}

